import { render, staticRenderFns } from "./ProgramDashboard.vue?vue&type=template&id=7c327e8f"
import script from "./ProgramDashboard.vue?vue&type=script&lang=js"
export * from "./ProgramDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports